
import React from 'react';
import { Belt } from './types';

interface TimelineTrackProps {
  belts: Belt[];
}

export const TimelineTrack: React.FC<TimelineTrackProps> = ({ belts }) => {
  // Meso timeline uses the original spacing
  const startX = 100;
  const beltSpacing = 230; // Reduced spacing for meso timeline
  const arrowPosition = startX + (belts.length * beltSpacing);
  
  return (
    <>
      {/* Main timeline line - fixed width approach */}
      <div 
        className="absolute top-1/2 transform -translate-y-1/2 z-0" 
        style={{ 
          left: startX - 40,
          width: arrowPosition - startX + 40,
          height: '16px',
          backgroundColor: '#4b5563'
        }} 
      />
      
      {/* Arrow at the end of timeline */}
      <div 
        className="absolute top-1/2 transform -translate-y-1/2 z-10"
        style={{ 
          left: arrowPosition
        }}
      >
        <div
          style={{
            width: 0,
            height: 0,
            borderTop: '18px solid transparent',
            borderBottom: '18px solid transparent',
            borderLeft: '36px solid #4b5563'
          }}
        />
      </div>
    </>
  );
};
